import React from 'react';
import { Playground as OriginalPlayground } from 'gatsby-theme-docz/src/components/Playground/index';
import styled from '@emotion/styled';

export const Playground = (props) => {
	const style = { padding: 12 };

	const Component = styled.div`
		div[data-testid="live-preview"] {
			padding: 15px;
		}
	`;
	return (
		<Component style={style} className='amigo'>
			<OriginalPlayground {...props} />
		</Component>
	);
};
